module.exports = __webpack_public_path__ + "images/Map-small-corsica-693f7484eef560951b7bb3d974028edf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Logos/Map-small-corsica.svg
// module id = 41
// module chunks = 0